// import React, { useState, useRef } from "react";
// import "./Home.css";
// // import Destinations from "./Destinations";
// import Highlights from "./Highlights";
// import Testimonials from "./Testimonials";
// import SocialComments from "../SocialComments/SocialComments";
// import CTASection from "../CTASection/CTASection";
// import MiceHighlights from "../Mice Vertical/MiceHighlights";
// import CustomerStories from "../AboutUs/CustomerStories";
// import TeamSection from "../AboutUs/TeamSection";

// import video1 from "../../assets/Events/homepagevdo.MP4";
// // import video2 from "../../assets/Events/STAGES VIDEO 2.webm";

// // new update 
// import { Link } from "react-router-dom";


// function Home() {
//   const videos = [video1];
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const videoRef = useRef(null);

//   // When video ends, go to next
//   const handleVideoEnd = () => {
//     setCurrentIndex((prev) => (prev + 1) % videos.length);
//   };

//   return (
//     <div className="home-container">
//       <div className="banner">
//         {/* <video
//           ref={videoRef}
//           src={videos[currentIndex]}
//           className="banner-video"
//           autoPlay
//           muted
//           playsInline
//           onEnded={handleVideoEnd}
//         /> */}
// <video
//   ref={videoRef}
//   src={videos[currentIndex]}
//   className="banner-video"
//   autoPlay
//   muted
//   loop
//   playsInline
// />
//         <div className="banner-overlay">
//           <h1 className="banner-heading">ATH Events</h1>
//         </div>
//       </div>

//       <div className="customerstories">
//         {" "}
//         <CustomerStories />
//       </div>
//       {/* <Destinations /> */}

//       {/* <CTASection /> */}
//       {/* new update */}
//        {/* <CTASection
//   heading="Plan Your Corporate Events & Group Trips with Us"
//   description="From Offsites and RnR Events to Domestic & International Travel Packages — enjoy smooth, end-to-end planning with our expert team."
//   buttonText="Call Us Now"
//   buttonLink="tel:+919876543210"
// /> */}

// <CTASection
//   heading="Plan Your Corporate Events & Group Trips with Us"
//   description="From Offsites and RnR Events to Domestic & International Travel Packages — enjoy smooth, end-to-end planning with our expert team."
//   buttonText="Contact Us"
//   buttonLink="/contact"
// />
//       <MiceHighlights/>
//       <Highlights />

//       <TeamSection />
//       <Testimonials />
//       <SocialComments />
//     </div>
//   );
// }

// export default Home;


import React, { useState, useRef } from "react";
import "./Home.css";
import Destinations from "./Destinations";
import Highlights from "./Highlights";
import Testimonials from "./Testimonials";
import SocialComments from "../SocialComments/SocialComments";
import CTASection from "../CTASection/CTASection";
// import MiceHighlights from "../Mice Vertical/MiceHighlights";
import CustomerStories from "../AboutUs/CustomerStories";
import TeamSection from "../AboutUs/TeamSection";
// import video1 from "../../assets/Events/HOME page video.webm";
// import video1 from "../../assets/Events/HOME page video1.webm";
import video1 from "../../assets/Events/homepagevdo.MP4";
// import video2 from "../../assets/Events/STAGES VIDEO 2.webm";
import { Link } from "react-router-dom";

function Home() {
  const videos = [video1];
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRef = useRef(null);

  const handleVideoEnd = () => {
    setCurrentIndex((prev) => (prev + 1) % videos.length);
  };
  const schemaData = {
    "@context": "https://schema.org",
    "@type": ["Organization", "TravelAgency", "EventPlanner"],
    "@id": "https://atlastravelhouse.com/#organization",
    name: "Atlas Travel House",
    url: "https://atlastravelhouse.com/",
    logo: "https://atlastravelhouse.com/static/media/logo1.66d15f79b08a7465ccf7.png",
    image:
      "https://atlastravelhouse.com/static/media/logo1.66d15f79b08a7465ccf7.png",
    description:
      "Atlas Travel House is a leading corporate event management and MICE travel company in India, offering conferences, incentive travel, group tours and business event solutions.",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Building A5, 3rd Floor, Shankar Garden, Vikaspuri Next to Kia Showroom | Metro Pillar No. 618 | Delhi India",
      addressLocality: "New Delhi",
      addressRegion: "Delhi",
      addressCountry: "IN",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-9876543210",
      contactType: "customer service",
      areaServed: "IN",
      availableLanguage: ["English", "Hindi"],
    },
    sameAs: [
      "https://www.instagram.com/atlastravelhouse_ath",
      "https://www.linkedin.com/company/atlas-travel-house/",
      "https://www.youtube.com/@AtlasTravelHouse",
    ],
  };

  return (
    <div className="home-container">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />

      <div className="banner">
        <video
          ref={videoRef}
          src={videos[currentIndex]}
          className="banner-video"
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnd}
        />

        <div className="banner-overlay">
          <h1 className="banner-heading">
            Corporate Events, MICE & Incentive Travel Company in India – Atlas
            Travel House
          </h1>
        </div>
      </div>

      <section className="homepage-seo-content">
        <h2  className="seo-heading">About Atlas Travel House</h2>
        <p className="seo-paragraph">
          Atlas Travel House is a leading corporate event management and MICE
          travel company in India, delivering end-to-end solutions for
          conferences, offsites, incentive tours and luxury group travel. We
          partner with top brands across industries to design seamless
          experiences — from venue sourcing, event production and branding to
          international travel planning and on-ground execution.
          <br />
          With extensive expertise in Meetings, Incentives, Conferences and
          Exhibitions (MICE), we manage corporate events across major Indian
          cities and global destinations. Our team specializes in business
          conferences, annual meets, leadership retreats, RnR celebrations and
          customized corporate tour packages tailored to specific business
          objectives.
          <br />
          From strategic planning and budgeting to logistics coordination and
          post-event support, Atlas Travel House ensures every project is
          executed with precision, creativity and measurable impact.
        </p>
      </section>

      <section className="homepage-seo-content">
        <h2 className="seo-heading">Corporate Events & MICE Solutions</h2>
        <p className="seo-paragraph">
          We specialize in corporate events, annual meets, product launches, RnR
          celebrations and large-scale conferences across India and
          international destinations. Our MICE (Meetings, Incentives,
          Conferences and Exhibitions) solutions are designed to align with your
          business goals while delivering seamless execution and measurable
          impact.
          <br />
          From venue selection, event branding and stage production to delegate
          management, travel coordination and on-site support, our experienced
          team manages every aspect of your corporate event with precision.
          Whether it is a leadership summit, sales conference, dealer meet or
          incentive reward program, we create structured, engaging and
          professionally managed experiences for organizations of all sizes.
        </p>
        <Link to="/mice">Explore Our Corporate MICE Solutions in India</Link>
      </section>

      <section className="homepage-seo-content">
        {/* <MiceHighlights /> */}

        <h2 className="seo-heading">Incentive Travel & Group Tour Packages</h2>
        <p className="seo-paragraph">
          Our team curates customized domestic and international travel packages
          for corporate groups, leadership teams and incentive achievers. From
          destination selection and visa assistance to hotel bookings and
          itinerary management, we ensure smooth and professionally managed
          travel experiences.
        </p>
        <Link to="/packages">Explore Corporate Tour Packages </Link>
      </section>

      <section className="homepage-trust-section">
        {/* <CustomerStories /> */}
        {/* <div className="customerstories">
          <h2>Why Leading Brands Trust Us</h2>
          <ul>
            <li>1000+ Successfully Executed Corporate Events</li>
            <li>Pan-India & International Destination Expertise</li>
            <li>End-to-End Event & Travel Management</li>
            <li>Transparent Planning & Budget Control</li>
            <li>Dedicated On-Ground Support Team</li>
          </ul>
        </div> */}
      </section>


      <Highlights />
  <CTASection
        heading="Plan Your Corporate Events & Group Trips with Us"
        description="From Offsites and RnR Events to Domestic & International Travel Packages — enjoy smooth, end-to-end planning with our expert team."
        buttonText="Contact Us"
        buttonLink="/contact"
      />
            <TeamSection />
      <Testimonials />
      {/* <SocialComments /> */}
    </div>
  );
}

export default Home;
